export { default } from "./GetERC20Allowance"
